import { Component, ElementRef, Input, NgModule } from '@angular/core';
import { HideEmptyDirective, WHideEmptyModule } from '@wipo/w-angular/directives';

import { CommonModule } from '@angular/common';

@Component({
    selector: 'f-facet-info',
    templateUrl: './f-facet-info.component.html',
    host: {
        class: 'b-input__info',
        '[class.b-input__info--is-error]': 'isError',
        '[class.b-input__info--dropdown]': 'isDropdown',
        '[class.b-notice]': 'isNotice',
        '[class.b-no-marker]': 'noMarker'
    },
    standalone: false
})
export class FFacetInfoComponent extends HideEmptyDirective {
  @Input() text?: string;
  @Input() isError: boolean = false; // if facet shows error
  @Input() isDropdown: boolean = false; // if facet shows dropdown
  @Input() isNotice: boolean = false; // dropdown has text (needs triangle)
  @Input() noMarker: boolean = false; // show no triangle

  constructor(protected override elRef: ElementRef) { super(elRef); }
}

@NgModule({
  imports: [CommonModule, WHideEmptyModule],
  exports: [FFacetInfoComponent],
  declarations: [FFacetInfoComponent]
})
export class FFacetInfoModule { }
